<template>
  <div class="personnel-education">
    <Personnel_education v-if="String(editpersonnel_temporary.personnel_etc_id_card).length > 11" :editpersonnel_temporary="editpersonnel_temporary" />
  </div>
</template>

<script>
import Personnel_education from '../../components/college/personnel_education.vue';
export default {
  components: {
    Personnel_education
  },
  data() {
    return {
      ApiKey: "HRvec2021",
      editpersonnel_temporary:[],
    };
  },

  mounted() {
    this.loadUserData();
  },

  methods: {
      async loadUserData() {
      try {
        this.loading = true;
        const userSession = JSON.parse(sessionStorage.getItem("user")) || {};
   
        const result = await this.$http.post("personnel_etc.php", {
          ApiKey: this.ApiKey,
          personnel_etc_id_card: userSession.personnel_etc_id_card
        });

        this.editpersonnel_temporary = result.data || {};
      } catch (error) {
        console.error("Error loading user data:", error);
        this.$toast.error("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>


<style scoped>
.personnel-education {
  padding: 20px;
}
</style>